module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "import-path"
  }, [_vm._v("\n  " + _vm._s(_vm.importStatement) + "\n  "), _c('i', {
    ref: "button",
    staticClass: "icon-copy",
    attrs: {
      "data-clipboard-text": _vm.importStatement
    }
  }, [_c('svg', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "fill": "currentColor",
      "preserveAspectRatio": "xMidYMid meet",
      "height": "1em",
      "width": "1em",
      "viewBox": "0 0 40 40"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "m31.6 35v-23.4h-18.2v23.4h18.2z m0-26.6c1.8 0 3.4 1.4 3.4 3.2v23.4c0 1.8-1.6 3.4-3.4 3.4h-18.2c-1.8 0-3.4-1.6-3.4-3.4v-23.4c0-1.8 1.6-3.2 3.4-3.2h18.2z m-5-6.8v3.4h-20v23.4h-3.2v-23.4c0-1.8 1.4-3.4 3.2-3.4h20z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8080f76e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vars/PathLine.vue
// module id = 1463
// module chunks = 1